import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import useDataSections from "../../../hooks/dataSections/useDataSections";
import DataSection from "./DataSection";
import DataSectionWithStepper from "./DataSectionWithStepper";
var DataSections = function () {
    var dataSections = useDataSections().dataSections;
    return (_jsx(_Fragment, { children: dataSections.map(function (dataSection) {
            if (dataSection.hasStepper) {
                return (_jsx(DataSectionWithStepper, { dataElements: dataSection.dataElements, heading: dataSection.heading, sectionName: dataSection.sectionName, headerToolTipText: dataSection.headerToolTipText, hasStepper: dataSection.hasStepper }, dataSection.heading));
            }
            return (_jsx(DataSection, { dataElements: dataSection.dataElements, heading: dataSection.heading, sectionName: dataSection.sectionName, headerToolTipText: dataSection.headerToolTipText }, dataSection.heading));
        }) }));
};
export default DataSections;
//# sourceMappingURL=DataSections.js.map